<div class="dialogContainer">
  <div class="wrapper">
    <label class="header">This interface allows users to release specific mod units
      and associated item with a requested ship date.</label>
    <div class="details">
      <ol class="list">
        <li>
          Unit Listing – Lists all units from the blanket order.
          Values in the fields from Unit Date through T-stat Order # means
          that unit and associated products has been released.
        </li>
        <li>Filters – Allows user to filter the units by the selected fields.</li>
        <li>Show Unreleased Units Only – when checked only unreleased units are displayed in the Unit Listing.</li>
        <li>
          Date Entry – User can enter a requested ship date for type of product associated with the unit.
          <ol class="nestedList" type="a">
            <li>Units – Enter the date that you would like the Units to ship</li>
            <li>Risers – Enter the date you would like the Risers (Risers and Riser Extensions) to ship</li>
            <li>FO – Enter the date you would like the Furnish Only Items (Panels and Grilles) to ship</li>
            <li>Thermostat – Enter the date you would like the Thermostats to ship</li>
          </ol>
        </li>
        <li>Paging Controls – These controls allow user to step through filtered pages.</li>
        <li>Release Quantity – Total number of units selected to release.</li>
        <li>Generate Release – When ready click this button to generate your release.</li>
      </ol>
      <div class="helpImage">
        <img alt="Release help image" width="1060" src="assets/ModReleaseHelp.png"/>
      </div>
    </div>
    <div mat-dialog-actions>
      <span class="spacer"></span>
      <span>
            <button class="primary-button" matButton="elevated" (click)="close()">Close</button>
        </span>
    </div>
  </div>
</div>
